// MoveMoneyPayeeConstants.js
/**
 * @module MoveMoneyPayeeConstants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

/**
 * @const MoveMoneyPayeeConstants
 */
const MoveMoneyPayeeConstants = keyMirror({
  MOVEMONEY_ADD_PAYEE_SERVICECALL: null,
  MOVEMONEY_ADD_PAYEE_FAILURE: null,
  MOVEMONEY_ADD_PAYEE_SUCCESS: null,
  MOVEMONEY_DELETE_PAYEE_DETAILS: null,
  MOVEMONEY_DELETE_PAYEE_SUCCESS: null,
  MOVEMONEY_DELETE_PAYEE_FAILED: null,
  MOVEMONEY_PUT_PAYEE_SUCCESS: null,
  MOVEMONEY_PUT_PAYEE_ERROR: null,
  MOVEMONEY_GROUP_ADD_PAYEE: null,
  MOVEMONEY_UPDATE_ALL_FORM_VALUES: null,
  MOVEMONEY_UPDATE_ALL_EDIT_FORM_VALUES: null,
  MOVEMONEY_UPDATE_EDIT_PAYEE_FORM: null,
  MOVEMONEY_EDIT_PAYEE_SERVICECALL: null,
  MOVEMONEY_MANAGE_PAYEE_SERVICE_SUCCESS: null,
  MOVEMONEY_UPDATE_BENEFICIARY_ID: null,
  MOVEMONEY_UPDATE_ALL_EDIT_FORM_VALUES_FROM_SHOW_VIEW: null,
  MOVEMONEY_RESET_PAYEE_DETAILS: null,
  MOVEMONEY_SAVE_ADD_PAYEE_DETAILS: null,
  MOVEMONEY_COMPANY_DETAILS: null,
  MOVEMONEY_COMPANY_SEARCH: null,
  MOVEMONEY_COMPANY_FAILURE: null,
  MOVEMONEY_UPDATE_ADD_COMPANY_FORM: null,
  MOVEMONEY_ADD_COMPANY_PAYEE_SERVICECALL: null,
  MOVEMONEY_ADD_COMPANY_SUCCESS: null,
  MOVEMONEY_ADD_COMPANY_FAILURE: null,
  MOVEMONEY_UPDATE_ADD_COMPANY_MANUALLY: null,
  MOVEMONEY_SRD_VERIFY: null,
  MOVEMONEY_SRD_SUCCESS: null,
  MOVEMONEY_SRD_FAILURE: null,
  MOVEMONEY_STORE_UNAUTHORISED_BENEFICIARY_DETAILS: null,
});

export default MoveMoneyPayeeConstants;
